<script setup lang="tsx">
import { getCSSVar } from "@zyzgroup/core-web";

const props = withDefaults(
  defineProps<{
    width?: string;
    height?: string;
    color?: string;
  }>(),
  {
    width: "24px",
    color: getCSSVar("--xg-green")
  }
);
</script>

<template>
  <svg
    viewBox="0 0 48 48"
    :width="props.width"
    :height="props.height ?? props.width"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="transform-origin: center"
  >
    <path
      d="M24 46.5C36.4264 46.5 46.5 36.4264 46.5 24C46.5 11.5736 36.4264 1.5 24 1.5C11.5736 1.5 1.5 11.5736 1.5 24C1.5 36.4264 11.5736 46.5 24 46.5Z"
      :fill="props.color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M35.5611 16.2017C34.9759 15.5994 34.0326 15.5994 33.4474 16.2017L21.0958 28.5444L14.5526 21.8106C13.9674 21.2084 13.0241 21.2084 12.4389 21.8106C11.8537 22.4129 11.8537 23.3836 12.4389 23.9859L20.0303 31.7983C20.6155 32.4006 21.5588 32.4006 22.144 31.7983L35.5611 18.3769C36.1463 17.7747 36.1463 16.8039 35.5611 16.2017Z"
      fill="white"
    />
  </svg>
</template>
